<template>
  <div>
    <!-- <pre>{{ workItems }}</pre> -->
    <!-- <pre>{{ arrWork }}</pre> -->
    <a-row class="mt-20">
      <!-- add new form -->
      <a-col :span="14" :offset="3">
        <a-form-item
          label="Work Experience (s)"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
          extra=""
        >
          <a-button type="dashed" block @click="addItemWork">
            + Add Work Experience
          </a-button>
        </a-form-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col :span="20" :offset="2">
        <!-- list form -->
        <a-form :layout="'horizontal'">
          <a-list
            class="demo-loadmore-list"
            :loading="loading"
            item-layout="horizontal"
            :data-source="workItems.slice().reverse()"
          >
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-list-item-meta>
                <p slot="title" class="mt-0 mb-0"></p>
                <div slot="description">
                  <a-row>
                    <a-col class="text-center" :span="20">
                      <a-row>
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Position</h6>
                        </a-col>
                        <a-col :span="12">
                          <!-- <a-select
                            show-search
                            placeholder="select..."
                            option-filter-prop="children"
                            v-model:value="item.position_level"
                          >
                            <a-select-option
                              v-for="(item, index) in optionPosition"
                              :key="index"
                              :value="item.value"
                            >
                              {{ item.text }}
                            </a-select-option>
                          </a-select> -->
                          <a-input type="text" v-model="item.position_name" placeholder="" />
                        </a-col>
                      </a-row>
                      <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Company Name</h6>
                        </a-col>
                        <a-col :span="12">
                          <a-input type="text" v-model="item.company_name" placeholder="" />
                        </a-col>
                      </a-row>
                      <!-- <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Company Type</h6>
                        </a-col>
                        <a-col :span="12">
                          <a-select
                            show-search
                            placeholder="select..."
                            option-filter-prop="children"
                            v-model:value="item.company_type"
                          >
                            <a-select-option
                              v-for="(item, index) in optionCompany"
                              :key="index"
                              :value="item.value"
                            >
                              {{ item.text }}
                            </a-select-option>
                          </a-select>
                        </a-col>
                      </a-row> -->
                      <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Job sectors</h6>
                        </a-col>
                        <a-col :span="12">
                          <a-select
                            show-search
                            placeholder="select..."
                            option-filter-prop="children"
                            v-model:value="item.job_sector"
                          >
                            <a-select-option
                              v-for="(item, index) in optionSector"
                              :key="index"
                              :value="item.value"
                            >
                              {{ item.text }}
                            </a-select-option>
                          </a-select>
                        </a-col>
                      </a-row>
                      <!-- <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Family owned business</h6>
                        </a-col>
                        <a-col :span="12">
                          <a-select
                            show-search
                            placeholder="select..."
                            option-filter-prop="children"
                            v-model:value="item.family_owned_business"
                          >
                            <a-select-option
                              v-for="(item, index) in ['yes', 'no']"
                              :key="index"
                              :value="item"
                            >
                              {{ item }}
                            </a-select-option>
                          </a-select>
                        </a-col>
                      </a-row> -->
                    </a-col>
                    <a-col class="text-center" :span="2">
                      <a-popconfirm
                        placement="topLeft"
                        ok-text="Yes"
                        cancel-text="No"
                        @confirm="removeItemWork(index, item)"
                      >
                        <template slot="title">
                          <p class="mt-0 mb-0">Confirm delete ?</p>
                        </template>
                        <a-button type="link" class="text-center">
                          <a-icon
                            style="font-size: 20px; color: red"
                            type="delete"
                          />
                        </a-button>
                      </a-popconfirm>
                    </a-col>
                  </a-row>
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-form>
      </a-col>
    </a-row>

    <!-- btn action -->
    <a-row class="mt-20">
      <a-col :span="10" :offset="5">
        <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button
            :disabled="btnSubmitLoad"
            type="primary"
            class="mr-10"
            @click="onSubmitWork"
          >
            <a-spin v-if="btnSubmitLoad" class="mr-10" /> Submit
          </a-button>
          <a-button type="danger" @click="backTomain"> Back </a-button>
        </a-form-item>
      </a-col>
    </a-row>
  </div>
</template>

<script>
const form = {
  id: "",
  company_name: '',
  company_industy: "",
  company_type: "",
  position_level: "",
  position_name: "",//รอใส่
  job_sector: "",
  family_owned_business: "no",
};
export default {
  props: {
    dataProfile: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formWork: Object.assign({}, form),
      arrWork: [],
      workItems: [],
      loading: false,
      btnSubmitLoad: false,
      // option form
      optionCompany: [],
      optionCompanyType: [],
      optionSector: [],
      optionPosition: [],
    };
  },
  mounted() {
    this.getDataOption();
  },
  methods: {
    backTomain(){
      this.$router
        .push({
          path: "/alumni/",
        })
        .catch((err) => {});
    },
    setDefaultWork() {
      if (this.dataProfile[0].work_detail.length !== 0) {
        this.arrWork = this.dataProfile[0].alumin_work;
        this.workItems = this.dataProfile[0].work_detail;
      }
    },
    async getDataOption() {
      this.loading = true
      const fetchSector = await this.$http.get(`/student_affair/job-sector/`);
      const fetchComtype = await this.$http.get(
        `/student_affair/company-type/`
      );
      const fetchIndusty = await this.$http.get(
        `/student_affair/company-industy/`
      );
      const fetchPositionLevel = await this.$http.get(
        `/student_affair/position-level/`
      );
      Promise.all([fetchSector, fetchComtype, fetchIndusty, fetchPositionLevel])
        .then((response) => {
          return Promise.all(response.map((r) => r.data));
        })
        .then(([listA, listB, listC, listD]) => {
          this.optionSector = listA.map((item) => {
            return {
              id: item.id,
              text: `${item.name_eng}`,
              value: item.id,
            };
          });
          this.optionCompanyType = listB.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionCompany = listB.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionPosition = listD.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
        })
        .catch((error) => {
          this.$emit("errorNotification", {
            errorMsg: error.response.status,
            urlPath: `fail call option list`,
          });
        });
      this.setDefaultWork();
      this.loading = false
    },
    addItemWork() {
      this.workItems.push(this.formWork);
    },
    async onSubmitWork() {
      for (let listForm = 0; listForm < this.workItems.length; listForm++) {
        var jsonBodyWork = {};
        const workList = this.workItems[listForm];
        const keys = Object.keys(workList);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          // //console.log(key, workList[key] )
          jsonBodyWork[key] = workList[key];
        }
        if (jsonBodyWork.id !== "") {
          // patch
          this.updateWork(jsonBodyWork);
        } else {
          // post
          this.addNewWork(jsonBodyWork);
        }
      }
    },
    updateMainProfile(dataJson) {
      return new Promise((resolve) => {
        this.$http
          .patch(
            "/student_affair/alumni-profile/" + this.dataProfile[0].id + "/",
            dataJson
          )
          .then((response) => {
            if (response.status) {
              this.$emit("updateObjMainProfile", { data: response.data });
              this.setDefaultWork();
              this.$emit("successNotification", {
                msg: "Success",
                des: `profile update`,
              });
              this.formWork = Object.assign({}, form);
              resolve(true);
            }
          })
          .catch((error) => {
            // //console.log(error);
            resolve(false);
          });
      });
    },
    async addNewWork(jsonData) {
      var jsonBody = {};
      try {
        const response = await this.$http.post(
          "/student_affair/work/",
          jsonData
        );
        if (response.status === 201) {
          this.btnSubmitLoad = true;
          this.arrWork.push(response.data.id);
          jsonBody["alumin_work"] = this.arrWork;
          this.updateMainProfile(jsonBody);
          this.btnSubmitLoad = false;
        } else {
          throw { response };
        }
      } catch (error) {}
    },
    updateWork(jsonData) {
      this.btnSubmitLoad = true;
      return new Promise((resolve) => {
        this.$http
          .patch("/student_affair/work/" + jsonData.id + "/", jsonData)
          .then((response) => {
            if (response.status) {
              this.btnSubmitLoad = false;
              resolve(true);
            }
          })
          .catch((error) => {
            // //console.log(error);
            resolve(false);
          });
      });
    },
    async removeItemWork(index, dataObj) {
      // //console.log(dataObj.id);
      if (dataObj.id === "") {
        const indexRemoveHtml = this.workItems.findIndex(
          (item) => item.id === ""
        );
        this.workItems.splice(indexRemoveHtml, 1);
      } else {
        try {
          const res = await this.$http.delete(
            `/student_affair/work/${dataObj.id}/`
          );
          if (res.status === 204) {
            var jsonUpdate = {};
            const indexDelPatch = this.arrWork.findIndex(
              (item) => item === dataObj.id
            );
            this.arrWork.splice(indexDelPatch, 1);
            const indexDel = this.workItems.findIndex(
              (itemDel) => itemDel.id === dataObj.id
            );
            this.workItems.splice(indexDel, 1);
            // create json
            jsonUpdate["alumin_work"] = this.arrWork;
            this.updateMainProfile(jsonUpdate);
          } else {
            throw { res };
          }
        } catch (error) {
          this.$emit("errorNotification", {
            errorMsg: error.response.status,
            urlPath: `/student_affair/work/${dataObj.id}/`,
          });
        }
      }
    },
  },
};
</script>